import React from 'react';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button, IconButton, Paper, Stack, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  onBack: () => void;
  canWrite: boolean;
  isLoading: boolean;
  isActionDisabled: boolean;
  aftermarketProductId?: string;
  handleSaveAftermarketProduct: () => Promise<void>;
}

export const PageHeader = ({
  onBack,
  canWrite,
  isLoading,
  isActionDisabled,
  aftermarketProductId,
  handleSaveAftermarketProduct,
}: Props) => (
  <Paper>
    <Stack direction="row" alignItems="center" justifyContent="space-between" padding="1rem">
      <Stack direction="row" alignItems="center">
        <IconButton size="small" onClick={onBack}>
          <ArrowBackIosIcon fontSize="small" sx={{ color: 'black' }} />
        </IconButton>

        <Typography variant="h5">{aftermarketProductId ? 'Edit' : 'Create'} Aftermarket Product</Typography>
      </Stack>

      <RenderWithCondition condition={canWrite}>
        <Button
          loading={isLoading}
          variant="contained"
          startIcon={<SaveIcon />}
          disabled={isActionDisabled}
          onClick={handleSaveAftermarketProduct}
        >
          {aftermarketProductId ? 'Update' : 'Create'}
        </Button>
      </RenderWithCondition>
    </Stack>
  </Paper>
);
